import WyInteractionsContactReasonsPage from '../components/interactions/anlaytics/wy-interactions-contact-reasons-page.vue'
import WyInteractionsPhraseCategoriesPage from '../components/interactions/anlaytics/wy-interactions-phrase-categories-page.vue'
import WyInteractionsCompareMetrics from '../components/interactions/anlaytics/wy-interactions-compare-metrics.vue'
import WyInteractionsMetrics from '../components/interactions/anlaytics/wy-interactions-metrics-page.vue'

export default [
  {
    path: '/interactions',
    name: 'interactionsContactReasonsPage',
    component: WyInteractionsContactReasonsPage,
    meta: { 
      bindModel: 'chat-interactions',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'directions', 'agentGroups', 'agentTeams', 'agents'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'direction-dropdown-widget'},
        {name:'interactions-filtering-widget'}
      ]
    }
  },
  {
    path: '/interactions/compareMetrics',
    name: 'compareMetrics',
    component: WyInteractionsCompareMetrics,
    props: true,
    meta: { 
      bindModel: 'chat-interactions',
      filterAction: 'fetchChatFilters',
      filterNames: ['directions', 'agentGroups', 'agentTeams', 'agents'],
      headerMenuItems: [
        {name:'date-widget', properties:{hidden: true, disableToday: true}},
        {name:'direction-dropdown-widget'},
        {name:'interactions-filtering-widget'}
      ]
    }
  },
  {
    path: '/interactions/metrics',
    name: 'metrics',
    component: WyInteractionsMetrics,
    meta: { 
      bindModel: 'chat-interactions',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'directions', 'agentGroups', 'agentTeams', 'agents'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'direction-dropdown-widget'},
        {name:'interactions-filtering-widget'}
      ]
    }
  },
  {
    path: '/interactions/phraseCategories',
    name: '/phraseCategoriesPage',
    component: WyInteractionsPhraseCategoriesPage,
    meta: { 
      bindModel: 'chat-interactions',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'directions', 'agentGroups', 'agentTeams', 'agents'],
      headerMenuItems: [
        {name:'date-widget', properties:{disableToday: true}},
        {name:'direction-dropdown-widget'},
        {name:'interactions-filtering-widget'}
      ]
    }
  }
]